import { render, staticRenderFns } from "./ViewOTView.vue?vue&type=template&id=1b2601a1&lang=pug"
import script from "./ViewOTView.vue?vue&type=script&lang=js"
export * from "./ViewOTView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports